// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Outer wrapper */
.Offers_outerContainer__AbIY2 {
  padding: 1rem 0;
  width: 100%;
  margin-top: 0.8rem;
}

/* Optional heading container */
.Offers_typographyContainer__feUsw {
  text-align: left;
  margin-bottom: 1rem;
}

/* Grid container for cards */
.Offers_container__zZTu5 {
  display: grid;
  gap: 1rem;
  width: 100%;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
}

/* Each card wrapper */
.Offers_cardWrapper__LI8Hg {
  width: 100%; /* fill grid cell */
}

/* Card design */
.Offers_cardContainer__3Q4NE {
  height: 14rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 1.5rem 1rem;
  border-radius: 0.5rem;
  background: rgba(101, 127, 173, 0.1);
  /* box-shadow: 0 6px 15px rgba(0, 0, 0, 0.08); */
  transition: all 0.3s ease;
  text-align: center;
}

.Offers_cardContainer__3Q4NE:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.12);
}

.Offers_off__YCJut {
  color: #1a1a1a;
  font-size: 3rem;
  font-weight: 800;
  margin: 0.5rem 0 0.3rem 0;
}

.Offers_offTitle__z21ES {
  color: #333;
  font-size: 1.2rem;
  font-weight: 600;
  margin-bottom: 1rem;
  min-height: 3rem;
}

.Offers_button__cqORJ {
  border-radius: 0.5rem;
  padding: 0.5rem 2rem;
  margin-top: 1.5rem;
}

.Offers_button__cqORJ:hover {
  background: #3b54c2;
  transform: scale(1.05);
}

/* ---------- MOBILE (Below 520px) ---------- */
@media (max-width: 520px) {
  .Offers_container__zZTu5 {
    grid-template-columns: 1fr; /* stack cards */
  }

  .Offers_cardContainer__3Q4NE {
    height: auto;
    padding: 1rem;
  }

  .Offers_off__YCJut {
    font-size: 2rem;
  }

  .Offers_offTitle__z21ES {
    font-size: 1rem;
  }

  .Offers_button__cqORJ {
    width: 100%;
    font-size: 0.95rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/Home/Offers.module.css"],"names":[],"mappings":"AAAA,kBAAkB;AAClB;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA,+BAA+B;AAC/B;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,SAAS;EACT,WAAW;EACX,2DAA2D;AAC7D;;AAEA,sBAAsB;AACtB;EACE,WAAW,EAAE,mBAAmB;AAClC;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,oBAAoB;EACpB,qBAAqB;EACrB,oCAAoC;EACpC,gDAAgD;EAChD,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA,+CAA+C;AAC/C;EACE;IACE,0BAA0B,EAAE,gBAAgB;EAC9C;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;AACF","sourcesContent":["/* Outer wrapper */\r\n.outerContainer {\r\n  padding: 1rem 0;\r\n  width: 100%;\r\n  margin-top: 0.8rem;\r\n}\r\n\r\n/* Optional heading container */\r\n.typographyContainer {\r\n  text-align: left;\r\n  margin-bottom: 1rem;\r\n}\r\n\r\n/* Grid container for cards */\r\n.container {\r\n  display: grid;\r\n  gap: 1rem;\r\n  width: 100%;\r\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\r\n}\r\n\r\n/* Each card wrapper */\r\n.cardWrapper {\r\n  width: 100%; /* fill grid cell */\r\n}\r\n\r\n/* Card design */\r\n.cardContainer {\r\n  height: 14rem;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  align-items: center;\r\n  padding: 1.5rem 1rem;\r\n  border-radius: 0.5rem;\r\n  background: rgba(101, 127, 173, 0.1);\r\n  /* box-shadow: 0 6px 15px rgba(0, 0, 0, 0.08); */\r\n  transition: all 0.3s ease;\r\n  text-align: center;\r\n}\r\n\r\n.cardContainer:hover {\r\n  transform: translateY(-5px);\r\n  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.12);\r\n}\r\n\r\n.off {\r\n  color: #1a1a1a;\r\n  font-size: 3rem;\r\n  font-weight: 800;\r\n  margin: 0.5rem 0 0.3rem 0;\r\n}\r\n\r\n.offTitle {\r\n  color: #333;\r\n  font-size: 1.2rem;\r\n  font-weight: 600;\r\n  margin-bottom: 1rem;\r\n  min-height: 3rem;\r\n}\r\n\r\n.button {\r\n  border-radius: 0.5rem;\r\n  padding: 0.5rem 2rem;\r\n  margin-top: 1.5rem;\r\n}\r\n\r\n.button:hover {\r\n  background: #3b54c2;\r\n  transform: scale(1.05);\r\n}\r\n\r\n/* ---------- MOBILE (Below 520px) ---------- */\r\n@media (max-width: 520px) {\r\n  .container {\r\n    grid-template-columns: 1fr; /* stack cards */\r\n  }\r\n\r\n  .cardContainer {\r\n    height: auto;\r\n    padding: 1rem;\r\n  }\r\n\r\n  .off {\r\n    font-size: 2rem;\r\n  }\r\n\r\n  .offTitle {\r\n    font-size: 1rem;\r\n  }\r\n\r\n  .button {\r\n    width: 100%;\r\n    font-size: 0.95rem;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"outerContainer": `Offers_outerContainer__AbIY2`,
	"typographyContainer": `Offers_typographyContainer__feUsw`,
	"container": `Offers_container__zZTu5`,
	"cardWrapper": `Offers_cardWrapper__LI8Hg`,
	"cardContainer": `Offers_cardContainer__3Q4NE`,
	"off": `Offers_off__YCJut`,
	"offTitle": `Offers_offTitle__z21ES`,
	"button": `Offers_button__cqORJ`
};
export default ___CSS_LOADER_EXPORT___;
